import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateMailbox, deleteMailbox, createMailbox, startMonitor, stopMonitor } from "../services/mailboxApi";

export function useCreateMailbox(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createMailbox,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);

      console.log(`${data.name} has been saved successfully!`);
      queryClient.setQueryData([queryData], (old) => (old ? [...old, data] : data));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateMailbox(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMailbox,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      console.log(`${data.name} has been saved successfully!`);
      queryClient.setQueryData([queryData], (old) =>
        old?.map((item) => (item.public_id === data.public_id ? data : item)),
      );
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useDeleteMailbox(queryData, handleSuccess, handleError) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteMailbox,
    onSuccess: (_, public_id) => {
      console.log(`${public_id} has been removed successfully!`);
      queryClient.setQueryData([queryData], (old) => old?.filter((item) => item.public_id !== public_id));
      handleSuccess?.();
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useStartMonitor(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: startMonitor,
    onSuccess: (data, public_id) => {
      if (extendedLog) console.log(data);
      console.log(`Monitor for mailbox ${public_id} has been started successfully!`);
      // Invalidate the specific monitor status query to refresh the status
      queryClient.setQueryData([queryData], (old) =>
        old?.map((item) => (item.public_id === data.public_id ? data : item)),
      );
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useStopMonitor(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: stopMonitor,
    onSuccess: (data, public_id) => {
      if (extendedLog) console.log(data);
      console.log(`Monitor for mailbox ${public_id} has been stopped successfully!`);
      // Invalidate the specific monitor status query to refresh the status
      queryClient.setQueryData([queryData], (old) =>
        old?.map((item) => (item.public_id === data.public_id ? data : item)),
      );
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}
